module.exports = __webpack_public_path__ + "img/8.2167c5b5.jpg";